import React from 'react';
import { capitalize } from 'utils/string_utils';

export default class QuestionMetadata extends React.Component {
  render() {
    const { data, questionType } = this.props;
    const incomingQuestionType = questionType.split(' ')[0];

    return (
      <div className="mt-10">
        <span className="fw-b">
          {t('practice.insights.question.incoming')}{' '}
          {capitalize(incomingQuestionType)}
        </span>
        {Object.entries(data).map(questionMetadata => (
          <div className="mt-10" key={questionMetadata[1]}>
            <div className="c-brand-gray-dark fz-base">
              {capitalize(questionMetadata[0])}
            </div>
            <div className="ws-pl">{questionMetadata[1]}</div>
          </div>
        ))}
      </div>
    );
  }
}
